// Module
var code = `<div class="webhooks-screen">
    <div class="webhooks-screen-header">
        <div class="webhooks-screen-header-title">{{secretKeyTitle}}</div>
        <div class="webhooks-screen-header-description">{{secretKeyDescription}}</div>
    </div>

    <div class="webhooks-screen-body">
        <div class="webhooks-screen-body-create-container">
            <div class="webhooks-screen-body-create-container-input-container">
                <terceraTextBox text="{{createKeyInputValue}}" placeholder="{{createKeyInputPlaceholder}}" />
            </div>
            <div class="webhooks-screen-body-create-container-button-container">
                <reactTooltipDecorator content="{{createKeyButtonTooltip}}" place="top">
                    <reactButton
                        type="{{createKeyButtonType}}"
                        text="{{createKeyButtonText}}"
                        icon="{{createKeyButtonIcon}}"
                        disabled="{{createKeyButtonIsDisabled}}"
                        on-onClick="@this.onCreateKeyButtonClicked()"/>
                </reactTooltipDecorator>
            </div>
        </div>
        <div class="webhooks-screen-body-list-container">
            <quickTableRactive name="webhooksTable" isAttached="false" />
        </div>
    </div>

    <div class="webhooks-screen-footer">
        <div class="webhooks-screen-footer-tip">{{secretKeyTip}}</div>
        <div class="webhooks-screen-footer-code-snippet">
            <reactWebhooksCodeSnippet webhookUrl="{{webhookBrandingUrl}}" on-onOpened="@this.resizePanelToFitScreen()" />
        </div>
        {{#if viewApiDocsUrl}}
            <div class="webhooks-screen-footer-view-api-docs">
                <reactLink href="{{viewApiDocsUrl}}" text="{{viewApiDocsText}}" />
            </div>
        {{/if}}
    </div>
</div>
`;
// Exports
export default code;